<!--component html goes here -->
<app-header></app-header>
  
<!-- <section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/Adventure.jpeg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
          <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> Adventures </h4>
              </div>
          </div> 
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a >Adventure</a></li>
              </ul>
          </nav>
      </div>
  </div> 
</section> -->
<!--end section-->
  <!--end section-->
  <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
<section class="bg-half" id="home">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
            <div class="section-title text-center mb-4 pb-2">
                <h4 ><span class="text-primary">Adventures</span></h4>
                <p class="text-muted para-desc mx-auto mb-0">All <span
                        class="text-primary fw-bold">Adventures</span> that may interest you around the world</p>
            </div>
        </div>
        <!--end col-->
    </div>
      <div class="row projects-wrapper">
        <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2" *ngFor="let data of rows">
          <div class="card work-container work-modern position-relative overflow-hidden shadow rounded border-0">
            <div class="card-body p-0" routerLink="/adventures-details/{{data.id}}">
              <img src="{{data.images}}" class="img-fluid rounded" alt="work-image">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a routerLink="/page-work-detail" class="title text-white d-block font-weight-bold">{{data.titleEn}}</a>
                <small class="text-light">{{data.countryNameEn}},{{data.cityNameEn}}</small>
              </div>
              <div class="client">
                <small class="text-light user d-block"><i class="mdi mdi-arrow-right"></i>{{data.numberOfDays}} Day Tour</small>
                <small class="text-light date"><i class="mdi mdi-calendar-check"></i>  {{data.date|date:'dd/MM/yyyy hh:MM'}}</small>
              </div>
            </div>
          </div>
        </div>
        <!-- PAGINATION START -->
        <div class="col-12">
          <ul class="pagination justify-content-center mb-0">
            <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous">Prev</a></li>
            <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next</a></li>
          </ul>
        </div>
        <!--end col-->
        <!-- PAGINATION END -->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </section>
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>